<script lang="ts">
	import { devices_status } from 'src/stores/device-runtime/status';
	import { beforeUpdate } from 'svelte';
	//Stores
	import { user_settings } from 'src/stores/account/user';
	import { auth_locked_devices } from 'src/stores/device-runtime/local-auth';
	import { devices } from 'src/stores/lists/devices';
	import { os } from 'src/stores/session/native-bridge';
	import { cloud_disabled_devices } from 'src/stores/device-runtime/firmware-ui';
	import { pin_unlocked_devices } from 'src/stores/device-runtime/pin-unlocked';

	//Helpers
	import { localReq } from '../../../services/http';
	import { hapticFeedback } from '../../../services/native_container_requests_ios';
	import { getStatus } from '../../../helpers/get_status_settings_helpers';
	import { get_local_ip, real_id } from '../../../helpers/interface_helpers';
	import { gen1CloudReq } from 'src/services/gen_1_reqs';
	import { unlockPin } from '../../../helpers/pin_lock_helpers';

	// might have to pass button component as a prop
	// import DoubleIconedButtonIndication from "./ControlButton/DoubleIconedButtonIndication.svelte";
	// import DoubleButton from './ControlButton/DoubleButton.svelte';
	import ControlsContainer from '@Shelly/shelly-design-system/ControlsContainer/ControlsContainer.svelte';
	import DeviceButtonV2 from '@Shelly/shelly-design-system/DeviceButtonV2/DeviceButtonV2.svelte';
	import Text from '@Shelly/shelly-design-system/Text/Text.svelte';
	import PinUnlock from '../../PinUnlock.svelte';
	import { toast } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import { hasControlRights } from 'src/helpers/user_helpers';

	export let device, status;

	let isLoadingOpen = false;
	let isLoadingClose = false;
	let local_ip = false;
	let direction = 'stop';
	// let ison = false;
	let pinLocked;
	let showModal = false;

	let callbackValue;

	let btn1 = false;
	let btn2 = false;

	$: hasRights = hasControlRights(device);

	beforeUpdate(() => {
		local_ip = get_local_ip(device.id);

		pinLocked =
			typeof $pin_unlocked_devices[device.id] === 'undefined' && $devices[device.id]?.pin_lock;

		if (
			device.category !== 'sensor' &&
			typeof status?.[device.category.split('s_')[0] + 's'] !== 'undefined'
		) {
			// ison = status?.rollers?.[0]?.state !== 'stop';
			direction = status?.rollers?.[0].state;
			btn1 = status?.rollers?.[0].state === 'open';
			btn2 = status?.rollers?.[0].state === 'close';
		}
	});

	//ToDO: merge the 2 functions the control is not different
	const handleRequestGen1 = async (dir) => {
		if ((dir === 1 && direction === 'open') || (dir === 0 && direction === 'close')) {
			direction = 'stop';
			if ($cloud_disabled_devices[device.id]) {
				btn1 = false;
				btn2 = false;

				setTimeout(() => {
					getStatus(device);
				}, 10000);
			}
		} else {
			direction = dir === 1 ? 'open' : 'close';
			if ($cloud_disabled_devices[device.id]) {
				btn1 = direction === 'open';
				btn2 = direction === 'close';

				setTimeout(() => {
					getStatus(device);
				}, 10000);
			}
		}

		let isok;
		let res;

		if (local_ip) {
			res = await localReq(
				device,
				`${local_ip}/roller/${device.channel}`,
				'post',
				{ go: direction },
				6000,
				true,
			);

			if (res.isok) {
				status.rollers[0] = res;

				devices_status.update_device_status({
					id: real_id(device.id),
					msg: status,
				});
			} else if (
				!res.isok &&
				typeof $cloud_disabled_devices[device.id] === 'undefined' // is not cloud disabled
				// $auth_locked_devices.indexOf[real_id(device.id)] < 0 // is not in the auth locked list
			) {
				res = await gen1CloudReq(device, 'roller', {
					go: direction,
				});
			}
		} else {
			res = await gen1CloudReq(device, 'roller', {
				go: direction,
			});
		}

		if (res.isok) {
			// good control
		} else if ($auth_locked_devices.indexOf(real_id(device.id)) == -1) {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
	};

	const handleRequest = async (dir) => {
		if (!pinLocked) {
			if ($os === 'IOS') {
				hapticFeedback('buttonPressed');
			}
			if (dir) {
				isLoadingOpen = true;
			} else {
				isLoadingClose = true;
			}

			await handleRequestGen1(dir);

			if (dir) {
				isLoadingOpen = false;
			} else {
				isLoadingClose = false;
			}
		} else {
			callbackValue = dir;
			showModal = true;
		}
	};

	const handlePin = () => {
		pinLocked = unlockPin(device, pinLocked);
		handleRequest(callbackValue);
		callbackValue = undefined;
	};
</script>

<ControlsContainer color="color-0">
	<svelte:fragment slot="first">
		<DeviceButtonV2
			aria-label={$format('label_direction_up_or_pause', { default: 'Direction Up or Pause' })}
			id="DeviceButtonV2-vk04nrd"
			icon={btn1 ? 'fa fa-pause' : 'fa fa-arrow-up'}
			aria-pressed={btn1}
			isActive={btn1}
			size="l"
			isLoading={isLoadingOpen}
			on:click={(e) => {
				e.stopPropagation();
				handleRequest(1);
			}}
			disabled={!hasRights}
		/>
		<Text styleType="controls-large" class="mt-s-plus text-bold"
			>{$format('text_device_control_direction_open', {
				default: 'Open',
			})}</Text
		>
	</svelte:fragment>
	<svelte:fragment slot="second">
		<DeviceButtonV2
			aria-label={$format('label_direction_down_or_pause', { default: 'Direction Down or Pause' })}
			id="DeviceButtonV2-w39xb9p"
			icon={btn2 ? 'fa fa-pause' : 'fa fa-arrow-down'}
			aria-pressed={btn2}
			isActive={btn2}
			size="l"
			isLoading={isLoadingClose}
			on:click={(e) => {
				e.stopPropagation();
				handleRequest(0);
			}}
			disabled={!hasRights}
		/>
		<Text styleType="controls-large" class="mt-s-plus text-bold"
			>{$format('text_device_control_direction_close', {
				default: 'Close',
			})}</Text
		>
	</svelte:fragment>
</ControlsContainer>

{#if showModal}
	<PinUnlock bind:showModal on:unlock={handlePin} on:cancel={() => (showModal = false)} />
{/if}
